import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';

export const StyledInfoBoardCardContainer = styled.article`
    color: ${(props) => props.theme.shades.darkGrey};
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
    display: flex;
    margin-bottom: 20px;

    @media ${mediaQueries.tablet} {
        /* 2 columns */
        width: calc(1 / 2 * 100%);
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        /* 3 columns */
        width: calc(1 / 3 * 100%);
    }
`;

export const StyledText = styled.p`
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    text-align: left;
    line-height: 1.6;
`;

export const StyledTopSection = styled.div`
    img {
        object-fit: cover;
        object-position: center center;
        height: 100%;
        width: 100%;
        user-select: none;
    }
`;

export const StyledImageWrapper = styled.div`
    width: 100%;
    overflow: hidden;
`;

export const StyledOnDemandPrice = styled.div`
    font-size: ${(props) => props.theme.fontSize.headlineM};
    font-weight: 600;
    color: ${(props) => props.theme.shades.blackGrey};
    line-height: 46px;
`;

export const StyledAspectRatio = styled.div`
    position: relative;

    &::before {
        position: relative;
        display: block;
        content: '';
        padding-bottom: calc(225 / 350 * 100%);

        @media ${mediaQueries.smallDesktopAndUp} {
            padding-bottom: calc(225 / 370 * 100%);
        }
    }
`;

export const StyledContentWrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
`;

export const StyledMiddleSection = styled.div`
    width: 100%;
    padding: 15px 10px 10px 10px;
    display: flex;
    flex-direction: column;
`;

export const StyledBorder = styled.hr`
    background: transparent;
    margin: 0 10px;
    border-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.shades.lightMidGrey};
`;

export const StyledCardHeadline = styled.span`
    display: flex;
    flex: auto;
    font-size: ${(props) => props.theme.fontSize.headlineS};
    font-weight: 700;
    line-height: 21px;
    margin: 0 0 8.5px;
    color: ${(props) => props.theme.shades.blackGrey};
`;

export const StyledInfoBox = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledBottomSection = styled.div`
    padding: 15px 10px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const StyledInfoCardLink = styled.a`
    color: ${(props) => props.theme.shades.blackGrey};
    text-decoration: none;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    &:focus,
    &:active,
    &:visited,
    &:hover {
        color: ${(props) => props.theme.shades.blackGrey};
        text-decoration: none;
    }
`;

export const StyledIconLabelList = styled.ul`
    padding-left: 0;
    list-style: none;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: space-between;
`;

export const StyledIconLabelListItem = styled.li`
    width: 50%;
    margin-bottom: 10px;
`;

export const StyledTextLabelList = styled.ul`
    padding-left: 0;
    list-style: none;
    display: flex;
    margin-top: 5px;
    flex-wrap: none;
    overflow: hidden;
    max-width: 100%;
    flex-wrap: wrap;
    /* @TODO this label list has to be abstracted */
    max-height: ${({ rows = 1 }: { rows: number }) => 30 * rows}px;
    flex-direction: row;
`;
export const StyledUserLove = styled.span`
    font-size: ${(props) => props.theme.fontSize.copyTextS};
    padding-top: ${(props) => props.theme.spacing.large};
    color: ${(props) => props.theme.shades.blackGrey};
    display: block;
`;
export const StyledTextLabelListItem = styled.li`
    margin: 2.5px 5px 2.5px 0;
    word-break: none;
    word-wrap: none;
    white-space: nowrap;

    & :last-child {
        margin-right: 0;
    }
`;
